import get from 'get-object-path';

export default {
    methods: {
        handleAccessToFeaturePage(featureId, club = null) {
            const clubToCheck = club ? club : this.selectedClub;

            if (!_.isEmpty(clubToCheck) && !this.canViewLudumFeature(featureId, clubToCheck)) {
                this.$router.push('/404');
            }
        },

        canViewLudumFeature(featureId, club = null) {
            const clubToCheck = club ? club : this.selectedClub;

            if (!this.hasFeatureSet(clubToCheck)) {
                return false;
            }

            const features = get(clubToCheck, 'club.data.subscription_info.data.subscription_plan.data.features.data');

            return !!_.find(features, ['subscription_feature_id', featureId]);
        },

        hasFeatureSet(club) {
            return club && get(club, 'club.data.subscription_info.data.subscription_plan.data.features');
        }
    },

    computed: {
        selectedClub() {
            return this.$store.getters.selectedClub;
        }
    }
};
